<template>
    <div id="willOverview">
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <BrokerReportPlansCard />
            </div>
        </div>
    </div>
</template>

<script>
import { http, httpGoCardless } from '@/services'
import { textFormat } from '@/mixins/TextFormat'

import BrokerReportPlansCard from '../Cards/BrokerReportPlans'

export default {
    name: 'ReportBrokerPlans',
    mixins: [textFormat],
    components: {
        BrokerReportPlansCard,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.backPath = from.path
        })
    },
    beforeRouteLeave(to, from, next) {
        next()
    },
    data() {
        return {
            data: null,
            backPath: null,
        }
    },
}
</script>

<style scoped>
.no-over {
    overflow: visible;
}
</style>
